import { Company } from "@/types/company"
import { createContext, useContext, useState, type Dispatch, type SetStateAction } from "react"

interface CompanyListsContextType {
  companyLists: Company[]
  setCompanyLists: Dispatch<SetStateAction<Company[]>>
}

const CompanyListsContext = createContext<CompanyListsContextType | undefined>(undefined)

export const CompanyListsProvider = ({
  initialCompanyLists,
  children,
}: {
  initialCompanyLists: Company[]
  children: React.ReactNode
}) => {
  const [companyLists, setCompanyLists] = useState(initialCompanyLists)

  return (
    <CompanyListsContext.Provider value={{ companyLists, setCompanyLists }}>{children}</CompanyListsContext.Provider>
  )
}

export const useCompanyLists = () => {
  const context = useContext(CompanyListsContext)
  if (context === undefined) {
    throw new Error("useCompanyLists must be used within a CompanyListsProvider")
  }
  return context
}
